module.exports = __webpack_public_path__ + "static/vip.36a47fb7.png";